var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowItWorks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 838.09 485.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#New_Gradient_Swatch_7);}.cls-7{fill:#addcc9;}.cls-8{fill:#fff;}.cls-9{fill:#ffa9a9;}.cls-10{fill:url(#New_Gradient_Swatch_10);}.cls-11{fill:url(#New_Gradient_Swatch_10-2);}.cls-12{fill:url(#New_Gradient_Swatch_10-3);}.cls-13{fill:#62c2d7;}.cls-14{fill:url(#New_Gradient_Swatch_10-4);}.cls-15{fill:url(#New_Gradient_Swatch_10-5);}.cls-16{fill:#e0e0e0;}.cls-17,.cls-43,.cls-44,.cls-45{fill:none;}.cls-18{fill:url(#New_Gradient_Swatch_10-6);}.cls-19{fill:#9695a9;}.cls-20{fill:#edac80;}.cls-21{fill:#a1a2bd;}.cls-22{fill:#636466;}.cls-23{fill:#dcddde;}.cls-24{fill:url(#New_Gradient_Swatch_9);}.cls-25{fill:url(#New_Gradient_Swatch_17);}.cls-26{fill:url(#New_Gradient_Swatch_16);}.cls-27{fill:url(#New_Gradient_Swatch_17-2);}.cls-28{fill:url(#New_Gradient_Swatch_16-2);}.cls-29{fill:url(#New_Gradient_Swatch_16-3);}.cls-30{fill:url(#New_Gradient_Swatch_16-4);}.cls-31{fill:url(#New_Gradient_Swatch_16-5);}.cls-32{fill:url(#New_Gradient_Swatch_17-3);}.cls-33{fill:url(#New_Gradient_Swatch_16-6);}.cls-34{fill:url(#New_Gradient_Swatch_17-4);}.cls-35{fill:url(#New_Gradient_Swatch_16-7);}.cls-36{fill:url(#New_Gradient_Swatch_16-8);}.cls-37{fill:url(#New_Gradient_Swatch_16-9);}.cls-38{fill:url(#New_Gradient_Swatch_16-10);}.cls-39{fill:url(#New_Gradient_Swatch_16-11);}.cls-40{fill:#b0dab5;}.cls-41{fill:#3ac2d7;}.cls-42{fill:#b498c6;}.cls-43,.cls-44{stroke:#3ac2d7;}.cls-43,.cls-44,.cls-45{stroke-miterlimit:10;}.cls-43{stroke-width:0.9px;}.cls-45{stroke:#fff;stroke-width:1.04px;}.cls-46{fill:url(#linear-gradient-6);}.cls-47{fill:url(#linear-gradient-7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 702,
    y1: 551.25,
    x2: 702,
    y2: 143.19,
    gradientTransform: "translate(1403.99 614.96) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdbddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9f7fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 56.98,
    y1: 551.25,
    x2: 56.98,
    y2: 143.19,
    gradientTransform: "translate(113.97 695.14) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdbddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f9f7fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 624.59,
    y1: 551.25,
    x2: 624.59,
    y2: 143.19,
    gradientTransform: "translate(1249.17 575.04) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 134.86,
    y1: 551.25,
    x2: 134.86,
    y2: 143.19,
    gradientTransform: "translate(269.71 550.98) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 545.24,
    y1: 551.25,
    x2: 545.24,
    y2: 143.19,
    gradientTransform: "translate(1090.49 514.48) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdbddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_7",
    cx: 347.98,
    cy: 477.11,
    r: 416.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4b2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8781bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_10",
    x1: 408.08,
    y1: 270.94,
    x2: 490.83,
    y2: 270.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89b54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#feca72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_10-2",
    x1: 354.77,
    y1: 334.44,
    x2: 461.95,
    y2: 334.44,
    xlinkHref: "#New_Gradient_Swatch_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_10-3",
    x1: 408.08,
    y1: 370.68,
    x2: 461.95,
    y2: 370.68,
    xlinkHref: "#New_Gradient_Swatch_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_10-4",
    x1: 325.33,
    y1: 270.94,
    x2: 408.08,
    y2: 270.94,
    xlinkHref: "#New_Gradient_Swatch_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_10-5",
    x1: 304.68,
    y1: 146.18,
    x2: 408.08,
    y2: 146.18,
    xlinkHref: "#New_Gradient_Swatch_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_10-6",
    x1: 418.56,
    y1: 172.16,
    x2: 564.25,
    y2: 172.16,
    xlinkHref: "#New_Gradient_Swatch_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_9",
    x1: 225.02,
    y1: 309.26,
    x2: 297.35,
    y2: 309.26,
    xlinkHref: "#New_Gradient_Swatch_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_17",
    x1: 404.13,
    y1: 339.32,
    x2: 428.65,
    y2: 339.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0ddf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e9fd9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16",
    x1: 404.13,
    y1: 340.14,
    x2: 428.65,
    y2: 340.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#95a6db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#c9ddf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#eef4fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddeaf7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_17-2",
    x1: 344.1,
    y1: 383.18,
    x2: 415.19,
    y2: 383.18,
    xlinkHref: "#New_Gradient_Swatch_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-2",
    x1: 333.32,
    y1: 434.22,
    x2: 360.62,
    y2: 434.22,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-3",
    x1: 399.21,
    y1: 434.22,
    x2: 426.51,
    y2: 434.22,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-4",
    x1: 345.46,
    y1: 384.82,
    x2: 415.18,
    y2: 384.82,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-5",
    x1: 338.49,
    y1: 409.68,
    x2: 341.71,
    y2: 409.68,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_17-3",
    x1: 107.73,
    y1: 339.32,
    x2: 132.25,
    y2: 339.32,
    xlinkHref: "#New_Gradient_Swatch_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-6",
    x1: 107.73,
    y1: 340.14,
    x2: 132.25,
    y2: 340.14,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_17-4",
    x1: 121.19,
    y1: 383.18,
    x2: 192.28,
    y2: 383.18,
    xlinkHref: "#New_Gradient_Swatch_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-7",
    x1: 175.76,
    y1: 434.22,
    x2: 203.06,
    y2: 434.22,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-8",
    x1: 109.87,
    y1: 434.22,
    x2: 137.17,
    y2: 434.22,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-9",
    x1: 121.2,
    y1: 384.82,
    x2: 190.92,
    y2: 384.82,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-10",
    x1: 166.77,
    y1: 336.3,
    x2: 361.19,
    y2: 336.3,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-11",
    x1: 193.95,
    y1: 409.68,
    x2: 197.79,
    y2: 409.68,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 20.83,
    y1: 129.05,
    x2: 113.22,
    y2: 129.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b498c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 831.74,
    y1: 265.75,
    x2: 752.6,
    y2: 265.75,
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "POP-UPS"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 668.13,
    y: 129.33,
    width: 67.73,
    height: 356.31,
    transform: "translate(1403.99 614.96) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.12,
    y: 209.5,
    width: 67.73,
    height: 276.13,
    transform: "translate(113.97 695.14) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 590.72,
    y: 89.41,
    width: 67.73,
    height: 396.23,
    transform: "translate(1249.17 575.04) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 100.99,
    y: 65.35,
    width: 67.73,
    height: 420.29,
    transform: "translate(269.71 550.98) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 511.38,
    y: 28.85,
    width: 67.73,
    height: 456.79,
    transform: "translate(1090.49 514.48) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M232.53,485.59H480.69A231.66,231.66,0,0,0,588.44,289.73c0-128-103.79-231.83-231.83-231.83S124.78,161.7,124.78,289.73A231.64,231.64,0,0,0,232.53,485.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M522.6,228.85V221.4a25.05,25.05,0,1,0-26.94,0v7.45H408.08v87.58h-7.45a25.05,25.05,0,1,0,0,26.94h7.45V431h202.1V228.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M610.18,431.39H408.08a.44.44,0,0,1-.44-.44V343.81h-6.77a25.49,25.49,0,1,1,0-27.82h6.77V228.85a.44.44,0,0,1,.44-.44h87.14v-6.77a25.49,25.49,0,1,1,27.82,0v6.77h87.14a.44.44,0,0,1,.44.44V431A.44.44,0,0,1,610.18,431.39Zm-201.66-.88H609.74V229.29H522.6a.44.44,0,0,1-.44-.44V221.4a.44.44,0,0,1,.21-.37,24.61,24.61,0,1,0-26.48,0,.43.43,0,0,1,.2.37v7.45a.44.44,0,0,1-.43.44H408.52v87.14a.44.44,0,0,1-.44.43h-7.45a.43.43,0,0,1-.37-.2,24.61,24.61,0,1,0,0,26.48.44.44,0,0,1,.37-.21h7.45a.44.44,0,0,1,.44.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M379.53,304.85A24.92,24.92,0,0,0,364.3,310a19,19,0,0,0,10.23,3H398A25,25,0,0,0,379.53,304.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M408.08,313h33.54a19.12,19.12,0,0,0,19.13-19.13v-1a78.53,78.53,0,0,1,21.92-54.39,104.41,104.41,0,0,0,8.16-9.64H408.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M495.66,221.4v.43a102.83,102.83,0,0,0,15.45-46.48c-.66,0-1.31-.1-2-.1a25,25,0,0,0-13.47,46.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M447.09,349.3a14.87,14.87,0,0,0,0-29.73h-77.5a14.9,14.9,0,0,0-14.82,14,24.9,24.9,0,0,0,5.7,12.57,14.73,14.73,0,0,0,9.12,3.17h25.76a25.33,25.33,0,0,0,5.28-5.93h7.45v5.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M462,370.68a14.9,14.9,0,0,0-14.86-14.86h-39v29.72h39A14.91,14.91,0,0,0,462,370.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M379.53,304.85a25,25,0,0,1,21.1,11.58h7.45V228.85H320.5v7.44a25.06,25.06,0,1,1-26.95,0v-7.44H206V431H408.08V343.37h-7.45a25,25,0,1,1-21.1-38.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M408.08,431.39H206a.44.44,0,0,1-.44-.44V228.85a.44.44,0,0,1,.44-.44h87.58a.44.44,0,0,1,.44.44v7.44a.45.45,0,0,1-.2.37,24.62,24.62,0,1,0,26.47,0,.45.45,0,0,1-.2-.37v-7.44a.44.44,0,0,1,.44-.44h87.58a.44.44,0,0,1,.44.44v87.58a.44.44,0,0,1-.44.43h-7.45a.43.43,0,0,1-.37-.2,24.61,24.61,0,1,0,0,26.48.44.44,0,0,1,.37-.21h7.45a.44.44,0,0,1,.44.44V431A.44.44,0,0,1,408.08,431.39Zm-201.67-.88H407.64v-86.7h-6.77a25.49,25.49,0,1,1,0-27.82h6.77v-86.7h-86.7v6.77a25.5,25.5,0,1,1-27.83,0v-6.77h-86.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M408.08,228.85H325.33A105.4,105.4,0,0,0,333,238c14.12,14.92,22.43,34.4,22.43,54.94v1A19.11,19.11,0,0,0,364.3,310,25,25,0,0,1,398,313h10.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M408.08,355.82H369.59a14.86,14.86,0,1,0,0,29.72h38.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M379.53,102.74a25,25,0,0,1,21.1,11.58h7.45V26.74H206v87.58h-7.45a25.06,25.06,0,1,0,0,27H206v87.58h87.58v7.44a25.06,25.06,0,1,0,26.95,0v-7.44h87.58V141.27h-7.45a25,25,0,1,1-21.1-38.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M307,282.89a25.48,25.48,0,0,1-13.91-46.83v-6.77H206a.44.44,0,0,1-.44-.44V141.71h-6.77a25.5,25.5,0,1,1,0-27.83h6.77V26.74a.44.44,0,0,1,.44-.44H408.08a.44.44,0,0,1,.44.44v87.58a.44.44,0,0,1-.44.44h-7.45a.45.45,0,0,1-.37-.2,24.62,24.62,0,1,0,0,26.47.45.45,0,0,1,.37-.2h7.45a.44.44,0,0,1,.44.44v87.58a.44.44,0,0,1-.44.44H320.94v6.77A25.48,25.48,0,0,1,307,282.89ZM206.41,228.41h87.14a.44.44,0,0,1,.44.44v7.44a.45.45,0,0,1-.2.37,24.62,24.62,0,1,0,26.47,0,.45.45,0,0,1-.2-.37v-7.44a.44.44,0,0,1,.44-.44h87.14v-86.7h-6.77a25.5,25.5,0,1,1,0-27.83h6.77V27.18H206.41v87.14a.44.44,0,0,1-.44.44h-7.45a.43.43,0,0,1-.36-.2,24.62,24.62,0,1,0,0,26.47.43.43,0,0,1,.36-.2H206a.44.44,0,0,1,.44.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M408.08,141.27h-7.45a25.06,25.06,0,1,1,0-27h7.45V63.52c-1.62,0-3.25,0-4.89.1-53.76,2.48-97.05,46.68-98.47,100.47a102.84,102.84,0,0,0,20.61,64.76h82.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M602.22,215.81l41.43,26.87,27.81-14.43s-9.53,16.93-10,17.24-18.59,7.34-18.59,7.34l-19-12.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M497.82,46,474.71,130.5l-7.19-2a25.05,25.05,0,1,0-7.11,26l7.18,2L444.48,241,529,264.08l2-7.18a25.05,25.05,0,1,1,26,7.11l-2,7.18,84.48,23.11L692.76,99.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M488.11,81.51l-13.4,49-7.19-2a25.05,25.05,0,1,0-7.11,26l7.18,2L444.48,241l79.82,21.84q3.36-2.61,6.51-5.5l.11-.41a25,25,0,0,1,25.18-41c.64.17,1.26.39,1.88.62.95-2.63,1.83-5.3,2.58-8.05A103.38,103.38,0,0,0,488.11,81.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M701.24,309.32l-12.26,66,20.89,85.39,1.3,6.61a6.24,6.24,0,0,1-.72,4.37,3.1,3.1,0,0,1-4.57.86,11.27,11.27,0,0,1-3.15-4.59l-45.16-86,22.32-61.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M709.87,460.72l-.64-2.61-11.1,1.11,4.6,8.75a11.27,11.27,0,0,0,3.15,4.59,3.1,3.1,0,0,0,4.57-.86,6.24,6.24,0,0,0,.72-4.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "698.13 459.22 671.46 364.76 665.5 360.09 657.57 382 698.13 459.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M682.11,211.6l-.33-8.27,16.41,6.86s1.48,10.59-7,17.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M681.2,221.93l-2.89-4.88,5.27-7.55,6.06,8.06,2.15-1.68s2.37,2.18-1.49,4.53l1,7.37-7.67-1.23,1-4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M657.58,308.43h0c-40.22,94.51-69,169.29-69,169.29-1.29,2.93-1.44,6.76,1.71,7.14h0a4,4,0,0,0,3.53-1.87c26.53-37.91,60.88-85.38,101-156a60.46,60.46,0,0,0,6.45-17.63S668.22,316.87,657.58,308.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M702.94,243.07a21.06,21.06,0,0,0-31.48-14.82l-28.82,18.57-42-32.26a2.22,2.22,0,0,0-3.07,3.18l44.11,49.32,25-11.58c0,10.32-6,39.08-8.54,50.89-.15.69-.32,1.38-.5,2.06h0c10.64,8.44,43.66.89,43.66.89C706.26,280.53,705.41,258.55,702.94,243.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M679.4,249.39l-12.79,6.09c0,10.32-6,39.08-8.54,50.89-.15.69-.32,1.38-.5,2.06h0c6,4.75,19,4.44,29.34,3.26h0C674,285.59,679.4,249.39,679.4,249.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M606.57,219.15l-6-4.59a2.22,2.22,0,0,0-3.07,3.18l7.05,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M666.07,255.73s-8.69,22.16-25.9,32.92l-.34,4.17,4.84.33s17.9-9.65,23.84-38.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M592.68,467.07c-2.7,6.89-4.15,10.65-4.15,10.65-1.29,2.93-1.44,6.76,1.71,7.14a4,4,0,0,0,3.53-1.87l6.05-8.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M701.24,309.32a143.59,143.59,0,0,1-22,3l-79.43,162h0c25.62-36.47,57.81-82,95-147.41A60.46,60.46,0,0,0,701.24,309.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "597.53 217.74 641.64 267.06 647.64 264.27 645.49 272.12 639.83 276.7 597.53 217.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M373.11,268,372,264.06a3.39,3.39,0,0,1,4.19-4.17l3.05.85,9.24-.63c2.79.28,6.2,2.38,6.89,5.1,1.11,4.45-1.17,9.84-6.53,16.85l-4.55-1L373.82,274Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M381.28,285.38l-36.17,37.26-50.56,8.65a1.69,1.69,0,0,0,.27,3.36l63.37.49,25.73-26.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M301.91,334.5H220.46a3.09,3.09,0,0,1-3.09-3.09H305A3.09,3.09,0,0,1,301.91,334.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M226.93,285.38h68.51a3.41,3.41,0,0,1,3.41,3.41v42.62a0,0,0,0,1,0,0H223.52a0,0,0,0,1,0,0V288.79A3.41,3.41,0,0,1,226.93,285.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M228.29,287.12h65.78a3.28,3.28,0,0,1,3.28,3.28v41a0,0,0,0,1,0,0H225a0,0,0,0,1,0,0v-41A3.28,3.28,0,0,1,228.29,287.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M311.22,385.15s-32.47,44.29-65.75,92.09a3.43,3.43,0,0,0,4.71,4.83c15.34-10.2,42.15-30.21,74.55-63.62l10.53-18.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M254.45,464.4q-4.45,6.35-9,12.84a3.43,3.43,0,0,0,4.71,4.83c4.1-2.73,9-6.17,14.67-10.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M324.73,418.45l10.53-18.56-5.42-3.32-18.62-11.42L264.85,471.7h0C280.27,460.2,301,442.92,324.73,418.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M404,369.33c-6.84-13.68-31.52-17.84-31.52-17.84-23.72,10.58-61.22,33.66-61.22,33.66,10.85,39.69,43.49,80.32,58,97a2.65,2.65,0,0,0,4.57-2.41c-8.41-32.43-25.71-84.31-25.71-84.31,24.7-6.3,39.4-13,48.14-18.62a27.81,27.81,0,0,0,7.74-7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M348.08,395.41c24.7-6.3,39.4-13,48.14-18.62a27.81,27.81,0,0,0,7.74-7.46h0c-2.24-4.49-6.41-7.95-11-10.57,0,0-40.78,16.81-65.35,32.1,5.71,33.4,20.45,65.76,34.6,83l1.84-.31,6.67-5.15C361.77,436.48,348.08,395.41,348.08,395.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M373.79,479.72c-1.41-5.46-3.08-11.47-4.88-17.69l-8.66,9.4c3.39,4.19,6.45,7.81,9,10.7A2.65,2.65,0,0,0,373.79,479.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 149.22,
    cy: 267.67,
    r: 14.26,
    transform: "matrix(0.94, -0.33, 0.33, 0.94, -80.79, 65.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M132,257.7a4.48,4.48,0,1,0,6-2.14A4.48,4.48,0,0,0,132,257.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M367.9,275.44l7,6,4.9-1a1.26,1.26,0,0,1,.75,2.39s5.55-2.19,8.32-1a34,34,0,0,0-2.18-2.72c-3.39-3.84-6.51-.35-8.3-8.12-1-4.26-3.75-3.15-3.75-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M392.18,286.43c-1.74-2.59-3.46-4.86-5.09-6.85.57.7,1.16,1.44,1.76,2.21-2.77-1.2-8.32,1-8.32,1a9.47,9.47,0,0,0-3.52,2.6c-11.58,13.63-25.19,36.09-25.19,36.09l-46.24-41.36a1.58,1.58,0,0,0-2.45,1.93c16.54,30.36,41.11,52.46,41.11,52.46h14.1l9.62-8,4.48,25s24.68,4.16,31.52,17.84h0a28.51,28.51,0,0,0,5.13-16.86C408.49,318.49,399.38,297.12,392.18,286.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M312.57,286.36l-7-6.25a1.58,1.58,0,0,0-2.45,1.93c1.59,2.93,3.26,5.78,5,8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M368,326.49l4.48,25s24.68,4.16,31.52,17.84h0c-12.44-24.15-19.25-62.4-19.25-62.4C374.07,322.19,368,326.49,368,326.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M406.36,378.36h0a2.92,2.92,0,0,0,3.51-2l18.7-72.79a2.72,2.72,0,0,0-2.16-3.28h0a2.93,2.93,0,0,0-3.51,2l-18.69,72.8A2.71,2.71,0,0,0,406.36,378.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M428.4,301.85l-23.72,71.4h0l-.47,1.84a2.71,2.71,0,0,0,2.15,3.27,2.92,2.92,0,0,0,3.51-2l18.7-72.79A2.56,2.56,0,0,0,428.4,301.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M346.68,383.53h0c-4.83-3.19-2.41-10.28,3.5-10.28h61.16c3.67,0,5.25,4.34,2.34,6.42l-3.37,2.42C390.58,396.27,366.77,396.8,346.68,383.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M334.44,483h0a1.47,1.47,0,0,0,1.75-1l24.38-94.95a1.34,1.34,0,0,0-1.07-1.63h0a1.46,1.46,0,0,0-1.76,1l-24.38,94.95A1.36,1.36,0,0,0,334.44,483Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M425.39,483h0a1.46,1.46,0,0,1-1.75-1l-24.39-94.95a1.36,1.36,0,0,1,1.08-1.63h0a1.46,1.46,0,0,1,1.76,1l24.38,94.95A1.36,1.36,0,0,1,425.39,483Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M410.31,382.09l3.37-2.42a3.4,3.4,0,0,0,1.49-3.09c-7.38-.14-46.75-.54-69.71,5.88a5.82,5.82,0,0,0,1.22,1.07C366.77,396.8,390.58,396.27,410.31,382.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 338.49,
    y: 336.3,
    width: 3.23,
    height: 146.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M148.92,282.78l88.86-41.25c3.4-1.58,4.87,2,1.62,3.9l-83.78,52.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M224.58,332.51l-39.43-9.24-22.82-33L159,285.45a7.7,7.7,0,0,0-2.8-2.52l-.31-.15s-5.53-2.19-8.31-1c-1.09,1.42-2.21,3-3.34,4.64-7.2,10.69-16.31,32.06-16.91,66a28.51,28.51,0,0,0,5.13,16.86h0c6.84-13.68,31.51-17.84,31.51-17.84l-.8-30.54,11.65,14.45H224.2C226.26,335.39,226.61,332.86,224.58,332.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M132.42,369.33c6.84-13.68,31.51-17.84,31.51-17.84,23.73,10.58,53.08,25,53.08,25,3.93,40.82,6,79.7,8.12,102.4a3.78,3.78,0,0,1-7.15,2c-18.89-37.51-29.68-85.54-29.68-85.54-24.7-6.3-39.4-13-48.14-18.62a27.81,27.81,0,0,1-7.74-7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M212.73,469.84l-9.67-83.63-55-29.82h0c-6.26,2.79-12.67,7-15.66,12.94h0a27.81,27.81,0,0,0,7.74,7.46c8.74,5.63,23.44,12.32,48.14,18.62C188.3,395.41,197.1,434.61,212.73,469.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M166.43,275.8l-4.93,5.62-4.9-1a1.26,1.26,0,0,0-.75,2.39s-5.55-2.19-8.32-1a34,34,0,0,1,2.18-2.72c3.39-3.84,6.51-.35,8.3-8.12,1-4.26,3.75-3.15,3.75-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M130,378.36h0a2.92,2.92,0,0,1-3.51-2l-18.7-72.79a2.72,2.72,0,0,1,2.16-3.28h0a2.93,2.93,0,0,1,3.51,2l18.69,72.8A2.71,2.71,0,0,1,130,378.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M108,301.85l23.72,71.4h0l.47,1.84a2.71,2.71,0,0,1-2.15,3.27,2.92,2.92,0,0,1-3.51-2l-18.7-72.79A2.56,2.56,0,0,1,108,301.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M189.7,383.53h0c4.83-3.19,2.41-10.28-3.5-10.28H125c-3.66,0-5.24,4.34-2.33,6.42l3.36,2.42C145.8,396.27,169.61,396.8,189.7,383.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M201.94,483h0a1.46,1.46,0,0,1-1.75-1L175.8,387.06a1.36,1.36,0,0,1,1.08-1.63h0a1.46,1.46,0,0,1,1.76,1L203,481.38A1.36,1.36,0,0,1,201.94,483Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M111,483h0a1.46,1.46,0,0,0,1.75-1l24.39-94.95a1.36,1.36,0,0,0-1.08-1.63h0a1.46,1.46,0,0,0-1.76,1l-24.38,94.95A1.36,1.36,0,0,0,111,483Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M126.06,382.09l-3.36-2.42a3.38,3.38,0,0,1-1.49-3.09c7.38-.14,46.75-.54,69.71,5.88a5.82,5.82,0,0,1-1.22,1.07C169.61,396.8,145.8,396.27,126.06,382.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M225.13,478.92c-.41-4.37-.82-9.34-1.24-14.8L212.82,470c1.64,3.7,3.37,7.36,5.16,10.92A3.78,3.78,0,0,0,225.13,478.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M213,335.4H224.2c2.06,0,2.41-2.54.38-2.89L213.86,330Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M237.78,241.53l-8.71,4,2,5.09,8.3-5.23C242.65,243.56,241.18,240,237.78,241.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M163.93,351.49l-.8-30.54-9.84-15.19s-22.44,33.62-20.87,63.57h0C139.26,355.65,163.93,351.49,163.93,351.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 166.77,
    y: 334.5,
    width: 194.42,
    height: 3.61,
    rx: 1.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 193.95,
    y: 336.3,
    width: 3.85,
    height: 146.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 261.18,
    cy: 310.26,
    r: 14.08,
    transform: "translate(-98.47 122.84) rotate(-22.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M259.85,316.54a3.35,3.35,0,0,1-2.37-1l-3.76-3.76a3.35,3.35,0,0,1,0-4.74,3.44,3.44,0,0,1,4.75,0l1.38,1.38,4-4.05a3.46,3.46,0,0,1,4.75,0h0a3.37,3.37,0,0,1,1,2.38,3.33,3.33,0,0,1-1,2.37l-6.42,6.42A3.39,3.39,0,0,1,259.85,316.54ZM256.1,307a2.47,2.47,0,0,0-1.76,4.22l3.76,3.76a2.49,2.49,0,0,0,3.51,0l6.41-6.42a2.47,2.47,0,0,0,0-3.51h0a2.54,2.54,0,0,0-3.5,0l-4.67,4.67-2-2A2.45,2.45,0,0,0,256.1,307Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M290.05,175.47a.22.22,0,0,1-.22-.21c-.92-25.56,2.92-48.26,11.42-67.49a109.2,109.2,0,0,1,29.06-39.25c21.26-18.15,43.31-22.66,43.53-22.71a.22.22,0,0,1,.26.18.22.22,0,0,1-.17.26c-.22,0-22.17,4.54-43.35,22.62C311,85.55,288.19,117.55,290.26,175.24a.22.22,0,0,1-.21.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M11.34,129.05a5.67,5.67,0,1,1-5.67-5.67A5.67,5.67,0,0,1,11.34,129.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M11.34,5.67A5.67,5.67,0,1,1,5.67,0,5.67,5.67,0,0,1,11.34,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M146.19,129.05a5.67,5.67,0,1,1-5.67-5.67A5.67,5.67,0,0,1,146.19,129.05Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 5.67,
    y1: 6.35,
    x2: 5.67,
    y2: 128.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M838.09,265.75a5.67,5.67,0,1,1-5.67-5.67A5.67,5.67,0,0,1,838.09,265.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M838.09,5.67A5.67,5.67,0,1,1,832.42,0,5.67,5.67,0,0,1,838.09,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M726.17,265.75a5.67,5.67,0,1,1-5.67-5.67A5.67,5.67,0,0,1,726.17,265.75Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 832.42,
    y1: 265.75,
    x2: 832.42,
    y2: 6.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 543.57,
    y1: 149.55,
    x2: 543.57,
    y2: 8.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M272.94,274.38a5.67,5.67,0,1,1-5.67-5.67A5.67,5.67,0,0,1,272.94,274.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M272.94,5.67A5.67,5.67,0,1,1,267.27,0,5.67,5.67,0,0,1,272.94,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M549.6,5.67A5.67,5.67,0,1,1,543.93,0,5.67,5.67,0,0,1,549.6,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M549.6,334.43a5.67,5.67,0,1,1-5.67-5.67A5.67,5.67,0,0,1,549.6,334.43Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: 267.27,
    y1: 274.38,
    x2: 267.27,
    y2: 27.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 267.27,
    y1: 75.3,
    x2: 267.27,
    y2: 5.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M442.16,334.43a5.67,5.67,0,1,1-5.67-5.67A5.67,5.67,0,0,1,442.16,334.43Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-45",
    points: "543.93 120.2 543.93 333.77 436.49 333.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 5.67,
    y: 128.53,
    width: 129.18,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 720.5,
    y: 265.23,
    width: 111.92,
    height: 1.04
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorks);
export default __webpack_public_path__ + "static/media/how_it_works.50d555b0153f829d4a7dcee5d0673e08.svg";
export { ForwardRef as ReactComponent };